import { useEffect, useState } from "react";
import { webUrlNode } from "../../../../constants/appInfo";
import ComposeMessageCard from "../ClickFunnels/ComposeMessageCard";

export default function EmailTemplatesPanel(selectedStep) {

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

 const [form, setForm] = useState({
  id: null,
  useCase: "",
  category: "transactional",
  subjectTemplate: "",
  htmlTemplate: "",
  textTemplate: "",
  actionsJson: "[]"
});

  useEffect(() => {
    loadTemplates();
  }, []);

  async function loadTemplates() {
    setLoading(true);
    const res = await fetch(`${webUrlNode}/api/email/templates`,);
    const data = await res.json();
    setList(data);
    setLoading(false);
  }

  function editTemplate(t) {
    setForm({
      id: t.id,
      useCase: t.useCase,
      category: t.category || "transactional",
      subjectTemplate: t.subjectTemplate || "",
      htmlTemplate: t.htmlTemplate || "",
      textTemplate: t.textTemplate || "",
      actionsJson: t.actionsJson
        ? JSON.stringify(
            typeof t.actionsJson === "string"
              ? JSON.parse(t.actionsJson)
              : t.actionsJson,
            null,
            2
          )
        : "[]"
    });
  }

  function resetForm() {
    setForm({
      id: null,
      useCase: "",
      category: "transactional",
      subjectTemplate: "",
      htmlTemplate: "",
      textTemplate: "",
      actionsJson: "[]"
    });
  }

  async function saveTemplate() {

    let actions;

    try {
      actions = JSON.parse(form.actionsJson || "[]");
    } catch (e) {
      alert("Invalid actionsJson");
      return;
    }

    const payload = {
      useCase: form.useCase,
      category: form.category,
      subjectTemplate: form.subjectTemplate,
      htmlTemplate: form.htmlTemplate,
      textTemplate: form.textTemplate,
      actionsJson: actions
    };

    if (form.id) {

      await fetch(`${webUrlNode}/api/email/templates/${form.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

    } else {

      await fetch(`${webUrlNode}/api/email/templates`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

    }

    resetForm();
    loadTemplates();
  }

  async function toggleStatus(t) {

    await fetch(`${webUrlNode}/api/email/templates/${t.id}/status`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        isActive: t.isActive === "true" ? "false" : "true"
      })
    });

    loadTemplates();
  }

  return (
    <div style={{  }}>

      {/* ---------- list ---------- */}

      <div style={{ }}>

        <h3>Email templates</h3>

        {loading && <div>Loading...</div>}

        {list.map(t => (
          <div
            key={t.id}
            style={{
              border: "1px solid #ddd",
              padding: 8,
              marginBottom: 8
            }}
          >
            <div style={{ fontWeight: 600 }}>
              {t.useCase}
            </div>

            <div style={{ fontSize: 12, color: "#666" }}>
              {t.subjectTemplate}
            </div>

            <div style={{ marginTop: 6 }}>
              <button onClick={() => editTemplate(t)}>
                Edit
              </button>

              <button
                style={{ marginLeft: 6 }}
                onClick={() => toggleStatus(t)}
              >
                {t.isActive === "true" ? "Disable" : "Enable"}
              </button>
            </div>
          </div>
        ))}

      </div>

      {/* ---------- editor ---------- */}

      <div style={{ flex: 1 }}>

        <h3>
          {form.id ? "Edit template" : "Create template"}
        </h3>

        <div>
          <label>Use case</label>
          <input
            value={form.useCase}
            disabled={!!form.id}
            onChange={e =>
              setForm({ ...form, useCase: e.target.value })
            }
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label>Category</label>
          <input
            value={form.category}
            onChange={e =>
              setForm({ ...form, category: e.target.value })
            }
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label>Subject</label>
          <input
            value={form.subjectTemplate}
            onChange={e =>
              setForm({ ...form, subjectTemplate: e.target.value })
            }
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label>HTML template</label>
          {selectedStep?.id&&<ComposeMessageCard
  message={{
    type: "email",
    subject: form.subjectTemplate,
    body: form.htmlTemplate,
    buttons: (() => {
      try {
        return JSON.parse(form.actionsJson || "[]");
      } catch {
        return [];
      }
    })()
  }}
  onChange={(msg) => {

    setForm(prev => ({
      ...prev,
      subjectTemplate: msg.subject || "",
      htmlTemplate: msg.body || "",
      actionsJson: JSON.stringify(msg.buttons || [])
    }));

  }}
/>}
        </div>

        <div>
          <label>Text template</label>
          <textarea
            rows={4}
            value={form.textTemplate}
            onChange={e =>
              setForm({ ...form, textTemplate: e.target.value })
            }
            style={{ width: "100%" }}
          />
        </div>

        <div>
          <label>actionsJson (buttons)</label>
          <textarea
            rows={6}
            value={form.actionsJson}
            onChange={e =>
              setForm({ ...form, actionsJson: e.target.value })
            }
            style={{ width: "100%", fontFamily: "monospace" }}
          />
        </div>

        <div style={{ marginTop: 8 }}>
          <button onClick={saveTemplate}>
            {form.id ? "Update" : "Create"}
          </button>

          <button
            style={{ marginLeft: 6 }}
            onClick={resetForm}
          >
            Clear
          </button>
        </div>

      </div>
    </div>
  );
}
